if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      get variantsData() {
        if (this._variantsData) return this._variantsData;
        const el = this.querySelector('[data-variants]');
        try {
          this._variantsData = el ? JSON.parse(el.textContent) : [];
        } catch (e) {
          this._variantsData = [];
        }
        return this._variantsData;
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);

          const optionValues = this.resolveOptionValues(target);

          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: optionValues,
            },
          });
        });
      }

      resolveOptionValues(target) {
        const variants = this.variantsData;
        const selected = this.selectedOptionValues;
        if (!variants.length) return selected;

        const selectedIds = selected.map(String);
        const changedId = target?.dataset?.optionValueId
          ? String(target.dataset.optionValueId)
          : null;

        const containsAll = (variant, ids) => {
          const values = variant.values.map(String);
          return ids.every((id) => values.includes(id));
        };

        let candidates = variants.filter((variant) => containsAll(variant, selectedIds));

        if (!candidates.length && changedId) {
          candidates = variants.filter((variant) => variant.values.map(String).includes(changedId));
        }

        if (!candidates.length) return selected;

        const pick = candidates.find((variant) => variant.available) || candidates[0];

        if (target && this.dataset.url) {
          target.dataset.productUrl = this.dataset.url;
        }

        this.applyVariantSelection(pick);
        return pick.values.map(String);
      }

      applyVariantSelection(variant) {
        const ids = variant.values.map(String);

        document.querySelectorAll('variant-selects').forEach((picker) => {
          picker.querySelectorAll('fieldset input[type="radio"]').forEach((input) => {
            const isMatch = ids.includes(String(input.dataset.optionValueId));
            if (input.checked !== isMatch) input.checked = isMatch;
          });
          picker.querySelectorAll('select').forEach((select) => {
            Array.from(select.options).forEach((option) => {
              const isMatch = ids.includes(String(option.dataset.optionValueId));
              option.selected = isMatch;
              if (isMatch) {
                option.setAttribute('selected', 'selected');
              } else {
                option.removeAttribute('selected');
              }
            });
          });
        });

        document
          .querySelectorAll('variant-selects select')
          .forEach((select) => this.updateSelectedSwatchValue({ target: select }));
        document
          .querySelectorAll('variant-selects fieldset input[type="radio"]:checked')
          .forEach((input) => this.updateSelectedSwatchValue({ target: input }));
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName, name } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          const previous = Array.from(target.options).find((option) => option.getAttribute('selected'));
          if (previous) previous.removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }

        const optionName = name.split('-')[0];
        const personalizeButtonOptionValue = document.querySelector(`.js-personalize-button-options [data-option-name="${optionName}"]`);

        if (personalizeButtonOptionValue) {
          personalizeButtonOptionValue.innerHTML = value;
        }
      }
    }
  );
}
